var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6654 26.2331V23.5896C22.6654 22.1875 22.1035 20.8427 21.1033 19.8512C20.1031 18.8597 18.7465 18.3027 17.332 18.3027H6.66536C5.25088 18.3027 3.89432 18.8597 2.89413 19.8512C1.89393 20.8427 1.33203 22.1875 1.33203 23.5896V26.2331",
    stroke: "#ABACAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 13.0172C14.9468 13.0172 17.3346 10.6502 17.3346 7.73027C17.3346 4.81039 14.9468 2.44336 12.0013 2.44336C9.05578 2.44336 6.66797 4.81039 6.66797 7.73027C6.66797 10.6502 9.05578 13.0172 12.0013 13.0172Z",
    stroke: "#ABACAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.668 26.2332V23.5897C30.6671 22.4183 30.2738 21.2803 29.5498 20.3545C28.8258 19.4287 27.8121 18.7675 26.668 18.4746",
    stroke: "#ABACAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.332 2.61523C22.4793 2.90641 23.4961 3.5678 24.2222 4.49514C24.9484 5.42248 25.3425 6.56301 25.3425 7.73693C25.3425 8.91085 24.9484 10.0514 24.2222 10.9787C23.4961 11.9061 22.4793 12.5674 21.332 12.8586",
    stroke: "#ABACAC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.abd96bd5e222a9563485a7157aa2f30c.svg";
export { ForwardRef as ReactComponent };